import {
  ControlBackgroundColors,
  ControlTextColors,
  NegativeColors,
  SecondaryColors,
} from '@picsart/design-system/foundation/colors';
import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';

import { createUseStyles } from 'react-jss';

import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { BreakPointsMedia } from '@picsart/design-system/foundation/responsive';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { canHover } from '@picsart/design-system/foundation/styleHelpers';
import { Timings } from '@picsart/design-system/foundation/timings';

const heightSmall = 44;

const useStyles = createUseStyles(
  {
    root: {
      display: 'flex',
      alignItems: 'center',
      padding: [Spacings.s0, Spacings.s12],
      borderRadius: CornerRadius.r8,
      fontWeight: FontWeights.medium,
      border: '1px solid #DCDDE9',
      fontSize: FontSizes.s16,
      lineHeight: LineHeights.l24,
      color: ControlTextColors.action,
      whiteSpace: 'nowrap',
      transitionProperty: 'border, color',
      transitionDuration: Timings.default,
      transitionTimingFunction: 'ease-in-out',
      cursor: 'pointer',
      height: heightSmall,

      [canHover]: {
        '&:hover': {
          background: ControlBackgroundColors.action,
          border: '1px solid #BCC0D1',
          color: '#282B36',
        },
      },
      '&.active': {
        color: NegativeColors.text.default,
        background: SecondaryColors.base.default,
      },

      [BreakPointsMedia.LG]: {
        padding: [0, Spacings.s24],
        borderRadius: `${heightSmall}px`,
        fontSize: FontSizes.s16,
      },
      [BreakPointsMedia.MD]: {
        padding: [0, Spacings.s24],
        borderRadius: `${heightSmall}px`,
        fontSize: FontSizes.s16,
      },
      [BreakPointsMedia.SM]: {
        padding: [0, Spacings.s24],
        borderRadius: `${heightSmall}px`,
        fontSize: FontSizes.s16,
      },
      [BreakPointsMedia.XS]: {
        padding: [0, Spacings.s24],
        borderRadius: `${heightSmall}px`,
        fontSize: FontSizes.s16,
      },
      [BreakPointsMedia.XXS]: {
        padding: [0, Spacings.s24],
        borderRadius: `${heightSmall}px`,
        fontSize: FontSizes.s16,
      },
    },
  },
  {
    name: 'tag',
  },
);

export default useStyles;
